
import { defineComponent, PropType, watch, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { formatMinuteToTime } from '@/utils/format'
import { TaskTimeSetting } from '@/views/dashboard/_components/task-time/task-time.service'
const TIME_STEP = 10
const MAX_NEXT_TIME = 1430
export default defineComponent({
  emits: ['update:modelValue'],

  props: {
    idx: {
      type: Number,
      default: 0
    },
    mainSwitch: {
      type: Boolean,
      default: false
    },
    mixType: {
      type: Number,
      default: 1
    },
    modelValue: {
      type: Object as PropType<TaskTimeSetting>,
      default: () => ({})
    },
    /** true: 显示和处理start_min、end_min。  false：不显示处理start_min */
    isRange: {
      type: Boolean,
      default: true
    },
  },
  setup (props, context) {
    const { t, locale } = useI18n()
    const compData = ref({} as { target: number, start_min: string, end_min: string })
    const WeekDayOptions = computed(() => {
      void locale.value
      return [
        { label: t('groupPolicySettings.schedWeekMon'), value: 1 },
        { label: t('groupPolicySettings.schedWeekTue'), value: 2 },
        { label: t('groupPolicySettings.schedWeekWed'), value: 3 },
        { label: t('groupPolicySettings.schedWeekThu'), value: 4 },
        { label: t('groupPolicySettings.schedWeekFri'), value: 5 },
        { label: t('groupPolicySettings.schedWeekSat'), value: 6 },
        { label: t('groupPolicySettings.schedWeekSun'), value: 7 },
      ]
    })

    function parseMinuteSelectTime (timeStr: any) {
      let parsedTime = 0
      const [hourTimeStr, minTimeStr] = timeStr.split(':')
      const hourTime = Number(hourTimeStr)
      const minTime = Number(minTimeStr)

      if (hourTime) {
        parsedTime = hourTime * 60
      }
      parsedTime = parsedTime + minTime
      return parsedTime
    }
    function fixEndTimeGreaterThanStartTime (start:number, end: number) {
      /** 使结束时间比开启时间大 */
      if (end <= start) {
        const nextTime = start + TIME_STEP
        if (nextTime >= MAX_NEXT_TIME - TIME_STEP) {
          end = MAX_NEXT_TIME
        } else {
          end = nextTime
        }
        compData.value.end_min = formatMinuteToTime(end) as any
      }
    }

    function updateStartTime () {
      fixEndTimeGreaterThanStartTime(parseMinuteSelectTime(compData.value.start_min), parseMinuteSelectTime(compData.value.end_min))
    }

    function setCompData () {
      compData.value = {
        target: props.modelValue.target || 1,
        start_min: formatMinuteToTime(props.modelValue.start_min || 0),
        end_min: formatMinuteToTime(props.modelValue.end_min || 0),
      }
    }

    let isUpdatingFromProps = false

    watch(compData, (value) => {
      if (isUpdatingFromProps) {
        isUpdatingFromProps = false
        return
      }
      const data: TaskTimeSetting = {
        ...props.modelValue,
        ...value,
        start_min: parseMinuteSelectTime(value.start_min),
        end_min: parseMinuteSelectTime(value.end_min),
      }
      if (JSON.stringify(data) === JSON.stringify(props.modelValue)) return
      context.emit('update:modelValue', data)
    }, { deep: true })

    watch(() => props.modelValue, () => {
      isUpdatingFromProps = true
      setCompData()
    }, { immediate: true })

    return {
      compData,
      WeekDayOptions,
      updateStartTime,
    }
  }
})
